import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import Button from "../../components/Button";
import FormField from "../../components/FormField";
import TextInput from "../../components/TextInput";
import Select from "../../components/Select";
import { useInviteMember } from "../../../hooks/useInviteMember";
import type { InviteMemberDto } from "../../../api/membersApi";

const EMPTY: InviteMemberDto = {
  user: { username: "", email: "", name: "" },
  role: "EDITOR",
  assignedParcoursIds: [],
};

export default function MemberInvitePage() {
  const navigate = useNavigate();
  const [draft, setDraft] = useState<InviteMemberDto>(EMPTY);
  const invite = useInviteMember();

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    invite.mutate(draft, { onSuccess: () => navigate("/admin/members") });
  };

  return (
    <form onSubmit={onSubmit}>
      <PageHeader
        title="Inviter un membre"
        description="L'invitation crée le compte utilisateur et envoie un e-mail."
        actions={
          <>
            <Button type="button" variant="ghost" onClick={() => navigate("/admin/members")}>
              Annuler
            </Button>
            <Button type="submit" variant="primary" loading={invite.isPending}>
              Envoyer l'invitation
            </Button>
          </>
        }
      />
      <div className="bo-card bo-card--narrow">
        <div className="bo-stack">
          <FormField label="Prénom" required>
            <TextInput
              value={draft.user.name ?? ""}
              onChange={(e) => setDraft({ ...draft, user: { ...draft.user, name: e.target.value } })}
              required
            />
          </FormField>
          <FormField label="Nom" required>
            <TextInput
              value={draft.user.username ?? ""}
              onChange={(e) => setDraft({ ...draft, user: { ...draft.user, username: e.target.value } })}
              required
            />
          </FormField>
          <FormField label="E-mail" required>
            <TextInput
              type="email"
              value={draft.user.email ?? ""}
              onChange={(e) => setDraft({ ...draft, user: { ...draft.user, email: e.target.value } })}
              required
            />
          </FormField>
          <FormField label="Rôle" required>
            <Select
              value={draft.role}
              onChange={(e) => setDraft({ ...draft, role: e.target.value as InviteMemberDto["role"] })}
            >
              <option value="ADMIN">Administrateur</option>
              <option value="EDITOR">Éditeur</option>
            </Select>
          </FormField>
        </div>
      </div>
      {invite.isError && <p className="bo-error-text">Erreur : {(invite.error as Error)?.message}</p>}
    </form>
  );
}
